import { Sidebar } from "@digital-services/ui";

import { MenuItem } from "./MenuItem";

interface NavigationItemProps {
  id: string;
  icon: React.ReactNode;
  label: string;
  url: string;
  exact?: boolean;
  onMenuClick?: () => void;
  target?: string;
}

interface NavigationProps {
  items: NavigationItemProps[];
}

export const Navigation = ({ items }: NavigationProps) => {
  return (
    <nav className="flex h-full flex-col justify-between">
      {items.map(({ id, icon, label, target, url, exact, onMenuClick }) => (
        <MenuItem
          key={`menu-item-key-${id}`}
          dataTestId={`navigation-menu-item-${id}`}
          href={url}
          target={target}
          exact={exact}
          onClick={onMenuClick}
        >
          {({ isActive }) => (
            <Sidebar.MenuItem
              key={`navigation-${id}`}
              icon={icon}
              label={label}
              isActive={isActive}
            />
          )}
        </MenuItem>
      ))}
    </nav>
  );
};
